import { Text } from '@user-portal/wikr-components';
import { Trans } from 'react-i18next';

import * as S from './styled';

import { CirceProps } from './types';

const Circle = ({ isFinished, isCurrentStep, label, id }: CirceProps) => {
    return (
        <S.CircleContainer>
            <S.Circle isFinished={isFinished} isCurrentStep={isCurrentStep}>
                {isFinished ? (
                    <S.CheckMark />
                ) : (
                    <Text color="text-secondary-subdued" type="small-text" bold>{`${id}`}</Text>
                )}
            </S.Circle>
            <S.LabelContainer>
                <Text type="caption" center>
                    <Trans i18nKey={label} />
                </Text>
            </S.LabelContainer>
        </S.CircleContainer>
    );
};

export default Circle;
